<template>
  <div>
    <div
      v-tml-tooltip.hover.top="
        disableTooltip ? false : {message: colorText, delay: 350, timeout: 2000}
      "
      class="color-square h-full"
      :class="defaultColor"
      :style="{
        background,
        backgroundSize: 'cover',
        minHeight: minHeight,
      }"
      @click="$emit('click', $event)"
    />
  </div>
</template>

<script>
import {isString, isObject} from 'lodash';

import {classify, isCssColorString} from '@teemill/utilities';

export default {
  name: 'TmlColorSquare',

  props: {
    color: [String, Object],

    disableTooltip: {
      type: Boolean,
      default: false,
    },

    minHeight: {
      type: String,
      default: null,
    },
  },

  computed: {
    colorText() {
      return isObject(this.color) ? this.color.text : this.color;
    },

    background() {
      if (isObject(this.color)) {
        return this.color.background;
      }

      if (isCssColorString(this.color)) {
        return this.color;
      }

      return null;
    },

    defaultColor() {
      if (this.color?.background) {
        return null;
      }

      return classify(this.color?.value || this.color);
    },
  },

  methods: {
    classify,

    isString,

    isObject,
  },
};
</script>

<style lang="scss" scoped>
@import '@teemill/common/assets/scss/colors.scss';

.color-square {
  @include product-colors;
  background-size: cover;
}
</style>
